import { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import AdminSideMenu from '../../components/AdminSideMenu';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';

const DriverAssign = () => {
    const navigate = useNavigate();
    const [carriers, setCarriers] = useState([]);
    const [selectedCarriers, setSelectedCarriers] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [filteredDrivers, setFilteredDrivers] = useState([]);
    const [selectedDrivers, setSelectedDrivers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [assigning, setAssigning] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const [cities, setCities] = useState([]);
    const [searchFilters, setSearchFilters] = useState({
        name: '',
        experience: '',
        cdl: '',
        trailer: '',
        state: '',
        city: '',
    });
    const STATES = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' }
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalDrivers, setTotalDrivers] = useState(0);
    const itemsPerPage = 80;

    useEffect(() => {
        const uniqueCities = extractCities(drivers);
        setCities(uniqueCities);
    }, [drivers]);

    const extractCities = (driversList) => {
        const citySet = new Set();
        driversList.forEach(driver => {
            if (driver.city && driver.city.trim() !== '') {
                citySet.add(driver.city);
            }
        });
        return Array.from(citySet).sort();
    };

    useEffect(() => {
        fetchCarriers();
    }, []);

    const fetchCarriers = async () => {
        try {
            const res = await api.get('/packageSubscribed/all-carriers');

            const subscriptionList = Array.isArray(res.data)
                ? res.data
                : res.data.subscriptions || res.data.data || [];

            const carrierList = subscriptionList.map(sub => ({
                _id: sub.carrierId,
                companyName: sub.companyName,
                identificationNumber: sub.identificationNumber,
                packageName: sub.packageName,
                status: sub.status,
                currentPeriodEnd: sub.currentPeriodEnd
            }));

            setCarriers(carrierList);
        } catch (error) {
            console.error('Error fetching carriers:', error);
            setCarriers([]);
        }
    };

    const fetchDrivers = async (page = 1, filters = null) => {
        try {
            setLoading(true);

            const appliedFilters = filters !== null ? filters : searchFilters;

            let queryParams = `page=${page}&limit=${itemsPerPage}`;

            if (appliedFilters.name?.trim()) {
                queryParams += `&name=${encodeURIComponent(appliedFilters.name.trim())}`;
            }
            if (appliedFilters.experience?.trim()) {
                queryParams += `&experience=${encodeURIComponent(appliedFilters.experience.trim())}`;
            }
            if (appliedFilters.cdl?.trim()) {
                queryParams += `&cdl=${encodeURIComponent(appliedFilters.cdl.trim())}`;
            }
            if (appliedFilters.trailer?.trim()) {
                queryParams += `&trailer=${encodeURIComponent(appliedFilters.trailer.trim())}`;
            }
            if (appliedFilters.state?.trim()) {
                queryParams += `&state=${encodeURIComponent(appliedFilters.state.trim())}`;
            }
            if (appliedFilters.city?.trim()) {
                queryParams += `&city=${encodeURIComponent(appliedFilters.city.trim())}`;
            }

            const res = await api.get(`/drivers/unassigned?${queryParams}`);

            const driversData = res.data.drivers || res.data || [];
            const pagination = res.data.pagination || {};

            setDrivers(driversData);
            setFilteredDrivers(driversData);
            setTotalPages(pagination.totalPages || 1);
            setTotalDrivers(pagination.totalCount || driversData.length);
            setCurrentPage(page);
            setSelectedDrivers([]);
        } catch (error) {
            console.error('Error fetching drivers:', error);
            setDrivers([]);
            setFilteredDrivers([]);
            setTotalPages(1);
            setTotalDrivers(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedCarriers.length > 0) {
            const delayDebounce = setTimeout(() => {
                fetchDrivers(1, searchFilters);
            }, 500);

            return () => clearTimeout(delayDebounce);
        }
    }, [searchFilters, selectedCarriers]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setSearchFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        const emptyFilters = {
            name: '',
            experience: '',
            cdl: '',
            trailer: '',
            state: '',
            city: '',
        };

        setSearchFilters(emptyFilters);
        if (selectedCarriers.length > 0) {
            fetchDrivers(1, emptyFilters);
        }
    };

    const carrierOptions = carriers.map(carrier => ({
        value: carrier._id,
        label: `${carrier.companyName} (${carrier.identificationNumber})${carrier.packageName ? ' - ' + carrier.packageName : ''}`
    }));

    const handleCarrierChange = async (selectedOptions) => {
        const newSelectedCarriers = selectedOptions || [];
        setSelectedCarriers(newSelectedCarriers);

        const emptyFilters = {
            name: '',
            experience: '',
            cdl: '',
            trailer: '',
            state: '',
            city: '',
        };
        setSearchFilters(emptyFilters);

        if (newSelectedCarriers.length > 0) {
            await fetchDrivers(1, emptyFilters);
        } else {
            setDrivers([]);
            setFilteredDrivers([]);
        }
    };

    const handleCheckboxChange = (driverId) => {
        setSelectedDrivers(prev =>
            prev.includes(driverId)
                ? prev.filter(id => id !== driverId)
                : [...prev, driverId]
        );
    };

    const handleAssignSelected = async () => {
        if (selectedCarriers.length === 0 || selectedDrivers.length === 0) {
            alert('Please select at least one carrier and one driver');
            return;
        }

        const carrierNames = selectedCarriers.map(c => c.label).join(', ');
        const confirmMessage = `Assign ${selectedDrivers.length} driver(s) to ${selectedCarriers.length} carrier(s)?\n\nCarriers: ${carrierNames}`;
        
        if (!window.confirm(confirmMessage)) {
            return;
        }

        try {
            setAssigning(true);
            let totalAssigned = 0;
            let failedAssignments = [];

            // Assign to each selected carrier
            for (const carrier of selectedCarriers) {
                try {
                    const res = await api.post('/driver-assignments/bulk-assign', {
                        carrierId: carrier.value,
                        driverIds: selectedDrivers
                    });

                    if (res.data.success) {
                        totalAssigned += res.data.assignedCount;
                    } else {
                        failedAssignments.push(carrier.label);
                    }
                } catch (err) {
                    console.error(`Assignment error for ${carrier.label}:`, err.response?.data || err.message);
                    failedAssignments.push(carrier.label);
                }
            }

            if (failedAssignments.length === 0) {
                setSuccessMessage(`✅ Successfully assigned ${selectedDrivers.length} driver(s) to ${selectedCarriers.length} carrier(s)`);
            } else {
                setSuccessMessage(`⚠️ Assigned ${totalAssigned} driver(s). Failed for: ${failedAssignments.join(', ')}`);
            }

            setSelectedDrivers([]);
            await fetchDrivers(currentPage);
            setTimeout(() => setSuccessMessage(''), 3000);
        } catch (err) {
            console.error('Assignment error:', err.response?.data || err.message);
            alert(err.response?.data?.message || 'Server error during assignment');
        } finally {
            setAssigning(false);
        }
    };

    const hasFilters = Object.values(searchFilters).some(value =>
        value && value.toString().trim() !== ''
    );

    const pageCount = totalPages;
    const currentDrivers = filteredDrivers;

    const goToPage = (page) => {
        fetchDrivers(page, searchFilters);
    };

    const hasActiveFilters = Object.values(searchFilters).some(value => value.trim() !== '');
    
    const [triggering, setTriggering] = useState(false);
    const triggerAssignment = async () => {
        if (!window.confirm('Auto-assign Drivers now? This will assign drivers to all carriers with active subscriptions.')) {
            return;
        }

        try {
            setTriggering(true);
            await api.post('/driver-assignments/auto-assign-trigger');
            alert('Auto-assignment successful!');
        } catch (error) {
            console.error('Error triggering assignment:', error);
            alert('Failed to assign Drivers');
        } finally {
            setTriggering(false);
        }
    };

    return (
        <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
            <AdminSideMenu />
            <div className="w-full md:ml-64 p-4 sm:p-6 lg:p-8">
                <div className="p-0 sm:p-6">
                    <div className="flex justify-between items-center gap-2 mb-4">
                        <h2 className="text-2xl font-bold flex-1">Assign Drivers to Carriers</h2>
                        <button
                            onClick={triggerAssignment}
                            disabled={triggering}
                            className="bg-blue-600 text-white px-5 py-2 rounded shadow hover:bg-blue-700 transition disabled:opacity-50"
                        >
                            {triggering ? 'Assigning...' : 'Auto Assign Drivers'}
                        </button>
                        <button
                            onClick={() => navigate('/admin/driver-assign-monitor')}
                            className="bg-blue-600 text-white px-5 py-2 rounded shadow hover:bg-blue-700 transition"
                        >
                            Daily Assign Report
                        </button>
                    </div>

                    <div className="mb-4">
                        <label className="block text-gray-700 font-semibold mb-2">
                            Select Carrier(s) <span className="text-sm font-normal text-gray-500">(You can select multiple)</span>
                        </label>
                        <Select
                            isMulti
                            isClearable
                            options={carrierOptions}
                            value={selectedCarriers}
                            onChange={handleCarrierChange}
                            className="w-full"
                            classNamePrefix="react-select"
                            placeholder="Select one or more carriers..."
                            menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                        />
                        {selectedCarriers.length > 0 && (
                            <p className="text-sm text-gray-600 mt-2">
                                Selected {selectedCarriers.length} carrier(s)
                            </p>
                        )}
                    </div>

                    {successMessage && (
                        <div className="mb-4 text-green-700 bg-green-100 border border-green-400 px-4 py-2 rounded">
                            {successMessage}
                        </div>
                    )}

                    {selectedCarriers.length === 0 ? (
                        <p className="text-gray-500 mt-6">Please select one or more carriers to assign drivers.</p>
                    ) : loading ? (
                        <p>Loading drivers...</p>
                    ) : (
                        <>
                            <div className="mb-4 bg-white border border-gray-300 rounded-md p-4">
                                <div className="flex items-center justify-between mb-3">
                                    <h3 className="text-lg font-semibold text-gray-700">Search Filters</h3>
                                    {hasActiveFilters && (
                                        <button
                                            onClick={clearFilters}
                                            className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                                        >
                                            Clear All
                                        </button>
                                    )}
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={searchFilters.name}
                                            onChange={handleFilterChange}
                                            placeholder="Search by name..."
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">Experience</label>
                                        <input
                                            type="text"
                                            name="experience"
                                            value={searchFilters.experience}
                                            onChange={handleFilterChange}
                                            placeholder="Search experience..."
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">CDL</label>
                                        <input
                                            type="text"
                                            name="cdl"
                                            value={searchFilters.cdl}
                                            onChange={handleFilterChange}
                                            placeholder="Search CDL..."
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">State</label>
                                        <select
                                            name="state"
                                            value={searchFilters.state}
                                            onChange={handleFilterChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                            <option value="">All States</option>
                                            {STATES.map(state => (
                                                <option key={state.code} value={state.code}>
                                                    {state.name} ({state.code})
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-xs font-medium text-gray-600 mb-1">City</label>
                                        <select
                                            value={searchFilters.city}
                                            name="city"
                                            onChange={handleFilterChange}
                                            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                                        >
                                            <option value="">All Cities</option>
                                            {cities.length > 0 ? (
                                                cities.map(city => (
                                                    <option key={city} value={city}>
                                                        {city}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="" disabled>No cities available</option>
                                            )}
                                        </select>
                                    </div>
                                </div>

                                <div className="mt-3 text-sm text-gray-600">
                                    {hasFilters ? (
                                        <>
                                            Found <span className="font-semibold">{totalDrivers}</span> driver(s) matching your search
                                            {currentDrivers.length > 0 && ` - Showing page ${currentPage} of ${totalPages}`}
                                        </>
                                    ) : (
                                        <>
                                            Showing <span className="font-semibold">{currentDrivers.length}</span> drivers
                                            {totalDrivers > 0 && ` - Page ${currentPage} of ${totalPages} (Total: ${totalDrivers})`}
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="border border-gray-300 bg-white rounded-md">
                                <div className="max-h-[500px] overflow-y-auto">
                                    <div className="w-full overflow-x-auto">
                                        <table className="min-w-[700px] min-w-full table-fixed border-collapse">
                                            <thead className="top-0 z-20">
                                                <tr>
                                                    <th className="py-2 px-4 border w-48 bg-black text-white">Name</th>
                                                    <th className="py-2 px-4 border w-32 bg-black text-white">Experience</th>
                                                    <th className="py-2 px-4 border w-32 bg-black text-white">CDL</th>
                                                    <th className="py-2 px-4 border w-32 bg-black text-white">Date of Join</th>
                                                    <th className="py-2 px-4 border w-64 bg-black text-white">Address</th>
                                                    <th className="py-2 px-4 border w-56 bg-black text-white">
                                                        <button
                                                            disabled={selectedDrivers.length === 0 || assigning}
                                                            onClick={handleAssignSelected}
                                                            className={`bg-blue-600 text-white px-4 py-1 rounded font-semibold hover:bg-blue-700 transition text-sm ${selectedDrivers.length === 0 || assigning ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                        >
                                                            {assigning ? 'Assigning...' : `Assign to ${selectedCarriers.length} Carrier(s)`}
                                                        </button>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody className="divide-y divide-gray-200">
                                                {currentDrivers.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="py-8 px-4 text-center text-gray-500">
                                                            {hasActiveFilters ? 'No drivers match your search criteria' : 'No unassigned drivers available'}
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    currentDrivers.map((driver) => (
                                                        <tr key={driver._id} className="hover:bg-gray-50">
                                                            <td className="py-2 px-4 border w-48">{driver.name}</td>
                                                            <td className="py-2 px-4 border w-32">{driver.experience}</td>
                                                            <td className="py-2 px-4 border w-32">{driver.cdl}</td>
                                                            <td className="py-2 px-4 border w-32">
                                                                {new Date(driver.createdAt).toLocaleDateString('en-US')}
                                                            </td>
                                                            <td className="py-2 px-4 border w-64">
                                                                {driver.address}, {driver.city}, {driver.state}
                                                            </td>
                                                            <td className="py-2 px-4 border w-56 text-center">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedDrivers.includes(driver._id)}
                                                                    onChange={() => handleCheckboxChange(driver._id)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {pageCount > 1 && currentDrivers.length > 0 && (
                                <div className="flex justify-center mt-6">
                                    <nav className="flex items-center space-x-2 shadow-md px-2 py-2 rounded-lg bg-white">
                                        <button
                                            onClick={() => currentPage > 1 && goToPage(currentPage - 1)}
                                            disabled={currentPage === 1}
                                            className={`h-9 w-9 flex items-center justify-center rounded-full ${currentPage === 1
                                                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                                                }`}
                                        >
                                            &laquo;
                                        </button>

                                        {Array.from({ length: pageCount }, (_, i) => i + 1)
                                            .filter(page =>
                                                page === 1 ||
                                                page === pageCount ||
                                                (page >= currentPage - 2 && page <= currentPage + 2)
                                            )
                                            .map((page, idx, arr) => {
                                                const prev = arr[idx - 1];
                                                return (
                                                    <span key={page} className="flex">
                                                        {prev && page - prev > 1 && (
                                                            <span className="h-9 w-9 flex items-center justify-center text-gray-500">...</span>
                                                        )}
                                                        <button
                                                            onClick={() => goToPage(page)}
                                                            className={`h-9 w-9 rounded-full ${currentPage === page
                                                                ? "bg-blue-600 text-white shadow-lg border border-blue-600"
                                                                : "bg-gray-100 text-gray-900 hover:bg-blue-100 hover:text-blue-700"
                                                                }`}
                                                        >
                                                            {page}
                                                        </button>
                                                    </span>
                                                );
                                            })}

                                        <button
                                            onClick={() => currentPage < pageCount && goToPage(currentPage + 1)}
                                            disabled={currentPage === pageCount}
                                            className={`h-9 w-9 flex items-center justify-center rounded-full ${currentPage === pageCount
                                                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                                : "bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700"
                                                }`}
                                        >
                                            &raquo;
                                        </button>
                                    </nav>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DriverAssign;